import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector, runInInjectionContext } from '@angular/core';
import Swal from 'sweetalert2';
import { Observer, catchError, throwError } from 'rxjs';
import { environment } from '@projectConfig';
import { StorageService } from './storage.service';
import { Auth, authState, getIdToken } from '@angular/fire/auth';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  API_URL!: string;

  httpOptions: { headers: HttpHeaders } = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'multipart/form-data',
      'x-access-token': '',
    })
  }

  TokenObserver: Observer<any> = {
    next: (user: any) => {
      if (user) {
        // Get the access token from the user
        runInInjectionContext(this.injector, () => {
          getIdToken(user).then((token) => {
            if (token) {
              this.storage.setUserToken(token);
              this.httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type': 'application/json',
                  Accept: 'multipart/form-data',
                  'x-access-token': this.storage.getUserToken() ? this.storage.getUserToken() : '',
                })
              }
            }
          });
        });
      }
    },
    error: (error: any) => {
      console.error('Error occurred:', error);
    },
    complete: () => {
      console.log('Token change observer completed');
    }
  };

  constructor(private http: HttpClient, private auth: Auth, private storage: StorageService, private injector: Injector) {
    this.API_URL = environment.BASE_API_PATH;
    // Set initial token
    this.updateHttpOptions();
  }

  private updateHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'multipart/form-data',
        'x-access-token': this.storage.getUserToken() ? this.storage.getUserToken() : '',
      })
    };
  }



  // SHOW ALERT AS A TOSATER WHEN REQUIRED
  alert(message: string, type: any, duraion?: number) {
    return Swal.fire({
      title: message,
      icon: type,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: duraion ? duraion : 5000,
      timerProgressBar: true,
    });
  }

  // SHOW ALERT AS A POPUP WHEN REQUIRED
  alertModal(message: string, type: any, CancelButton = false, isIcon?: boolean) {
    return Swal.fire({
      text: message,
      icon: isIcon ? type : null,
      showConfirmButton: true,
      showCancelButton: CancelButton,
      confirmButtonText: 'Ok',
    });
  }

  get(path: string, params: HttpParams = new HttpParams()) {
    return this.http.get(`${this.API_URL}${path}`, { headers: this.httpOptions.headers, params })
      .pipe(catchError(this.formatErrors));
  }

  post(path: string, data: any = {}, params: HttpParams = new HttpParams(),) {
    return this.http.post(`${this.API_URL}${path}`, data, { headers: this.httpOptions.headers, params })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, data: any = {}, params: HttpParams = new HttpParams(),) {
    return this.http.put(`${this.API_URL}${path}`, data, { headers: this.httpOptions.headers, params })
      .pipe(catchError(this.formatErrors));
  }

  delete(url: string, params: HttpParams = new HttpParams(),) {
    return this.http.delete(`${this.API_URL}${url}`, { headers: this.httpOptions.headers, params })
      .pipe(catchError(this.formatErrors));
  }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  FetchLatestToken() {
    runInInjectionContext(this.injector, () => {
      authState(this.auth).subscribe(this.TokenObserver);
    });
  }

}
